export default __webpack_public_path__ + "static/First-e4aae675863ebc0b3625d759dc47197f.svg";